import React from 'react'
import { Card, CardContent, Grid, Typography, Avatar } from '@mui/material'
import { Cloudinary } from '@cloudinary/url-gen'

const TeacherInfo = ({ profileTeacher, teacherInfo }) => {

  const cld = new Cloudinary({
    cloud: {
      cloudName: 'youspeak'
    }
  })

  let teacherImage = ''
  if (profileTeacher && profileTeacher.teacherAvatar) {
    const cldRes = cld.image(profileTeacher.teacherAvatar)

    teacherImage = cldRes.toURL()
  }

  return (
    <Card>
      <CardContent>
        <Grid container direction="column" alignItems="center">
          <Grid item>
            <Typography
              variant="h6"
              style={{ textTransform: 'uppercase', fontWeight: '600' }}
            >
              Thông tin giáo viên
            </Typography>
          </Grid>

          <Grid item container direction="column" style={{ marginTop: '1em' }}>
            <Grid item>
              <Avatar src={teacherImage && teacherImage} style={{ width: '100px', height: '100px', margin: 'auto' }} />
            </Grid>

            <Grid item>
              <Typography variant="body1">
                <strong>Tên giáo viên:</strong>&nbsp;
                {teacherInfo &&
                  teacherInfo.name}
              </Typography>
            </Grid>

            <Grid item>
              <Typography variant="body1">
                <strong>Skype ID:</strong>&nbsp;
                {profileTeacher &&
                  profileTeacher.skypeId &&
                  profileTeacher.skypeId}
              </Typography>
            </Grid>

            <Grid item>
              <Typography variant="body1">
                <strong>Số điện thoại:</strong>&nbsp;
                {profileTeacher &&
                  profileTeacher.phoneNumber &&
                  profileTeacher.phoneNumber}
              </Typography>
            </Grid>

            <Grid item>
              <Typography variant="body1">
                <strong>Email:</strong>&nbsp;
                {teacherInfo &&
                  teacherInfo.email}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default TeacherInfo
